const my_profile = {
  viewMyClubSeacretProfile: "Voir mon profil ClubSeacret", // translated
  unverifiedEmail: "E-mail non vérifié", // translated
  viewMoreDetails: "Afficher plus de détails", // translated
  verifiedEmail: "E-mail vérifié", // translated
  createdFrom: "Créé à partir de", // translated
  createdTo: "Créé jusqu'à", // translated
  selectStatus: "Sélectionner le statut...", // translated
  searchByTitle: "Rechercher par titre...", // translated
  pushNotifications: "Notifications Push",
  pushNotificationsDescription: "Recevoir des notifications du navigateur pour les mises à jour et événements importants",
  pushNotificationsNotSupported: "Les notifications push ne sont pas prises en charge dans ce navigateur",
  pushNotificationsDeniedMessage: "L'autorisation de notification a été refusée. Veuillez activer les notifications dans les paramètres de votre navigateur pour recevoir des notifications push.",
  pushNotificationsEnabled: "Notifications push activées avec succès",
  pushNotificationsDisabled: "Notifications push désactivées avec succès",
  userInformationMissing: "Les informations utilisateur sont manquantes",
  failedToUpdatePushNotifications: "Échec de la mise à jour des paramètres de notifications push",
  notificationPermissionDenied: "L'autorisation de notification a été refusée. Veuillez l'activer dans les paramètres de votre navigateur.",
  notificationPermissionRequired: "L'autorisation de notification est requise pour activer les notifications push",
  notSupported: "Non pris en charge",
  permissionDenied: "Autorisation refusée",
  permissionNotRequested: "Autorisation non demandée",
  enabled: "Activé",
  disabled: "Désactivé",
};

export default my_profile;
